import ReactECharts from "echarts-for-react";

export type PieChartProps = {
  options?: any;
  style?: { height?: string; width?: string };
};

const PieChart = ({ style, options }: PieChartProps) => {
  // Default options
  const defaultOptions = {
    tooltip: {
      trigger: "item",
      // eslint-disable-next-line no-template-curly-in-string
      formatter: "{b} : {c}",
    },
    series: [
      {
        name: "Pie Chart",
        type: "pie",
        radius: ["30%", "45%"],
        color: [
          "var(--mui-palette-secondary-100)",
          "var(--mui-palette-info-700)",
          "var(--mui-palette-info-main)",
          "var(--mui-palette-primary-main)",
          "var(--mui-palette-secondary-700)",
        ],
        avoidLabelOverlap: true,
        emphasis: {
          label: {
            show: true,
            fontSize: 20,
            fontWeight: 500,
            fontFamily: "Inter",
          },
        },
        labelLine: {
          show: false,
        },
      },
    ],
  };

  // Merge the default options with the provided options (if any)
  const mergedOptions = {
    ...defaultOptions,
    ...options,
    series: defaultOptions.series.map((defaultSeries, index) => ({
      ...defaultSeries,
      ...(options?.series?.[index] || {}),
    })),
  };

  return <ReactECharts style={style} option={mergedOptions} opts={{ renderer: "svg" }} />;
};

export default PieChart;
